import { ReactElement } from 'react';
import { Brands } from '@delta-defense/client-environments';
import { Levels } from '../../core/enums/module';

type Benefit = {
	details: ReactElement,
	hideOnMobile?: boolean
}

type Benefits = {
	[brandID in Brands]: {
		[level in Levels]: Benefit[]
	}
}

export class LevelSelectionChartData {
	private static data: Benefits = {
		[Brands.USCCA]: {
			[Levels.Gold]: [
				{ details: (<li><img src="https://offers.deltadefense.com/images/lifelock.avif" alt="LifeLock logo" />
					<span><b>Identity Theft Protection -</b> LifeLock Standard ($124.99 Value)</span></li>) },
				{ details: (<li><b>150+</b> Video Series Episodes</li>) },
				{ details: (<li><b>30+</b> Guides, eBooks & Checklists</li>) },
				{ details: (<li><b>LEVEL 1</b> Qualification</li>) },
				{
					details: (<li><b>$2M</b> Annual Liability Insurance*</li>),
					hideOnMobile: true
				},
				{
					details: (<li><b>$10</b> Annual Anniversary Gift</li>),
					hideOnMobile: true
				}
			],
			[Levels.Platinum]: [
				{ details: (<li><img src="https://offers.deltadefense.com/images/lifelock.avif" alt="LifeLock logo" />
					<span><b>Identity Theft Protection -</b> LifeLock Standard ($124.99 Value)</span></li>) },
				{ details: (<li><b>290+</b> Video Series Episodes</li>) },
				{ details: (<li><b>40+</b> Guides, eBooks & Checklists</li>) },
				{ details: (<li><b>LEVEL 1 & 2</b> Qualification</li>) },
				{
					details: (<li><b>$2M</b> Annual Liability Insurance*</li>),
					hideOnMobile: true
				},
				{ details: (<li><b>$15</b> Annual Anniversary Gift</li>) },
				{ details: (<li><span>+</span> Quarterly Tactical Master Video Series</li>) },
				{ details: (<li><span>+</span> Quarterly Attorney Insider Video Series</li>) }
			],
			[Levels.Elite]: [
				{ details: (<li><img src="https://offers.deltadefense.com/images/lifelock.avif" alt="LifeLock logo" />
					<span><b>Identity Theft Protection -</b> LifeLock Ultimate Plus ($339.99 Value)</span></li>) },
				{ details: (<li><b>430+</b> Video Series Episodes</li>) },
				{ details: (<li><b>80+</b> Guides, eBooks & Checklists</li>) },
				{ details: (<li><b>LEVEL 1, 2 & 3</b> Qualification</li>) },
				{
					details: (<li><b>$2M</b> Annual Liability Insurance*</li>),
					hideOnMobile: true
				},
				{ details: (<li><b>$25</b> Annual Anniversary Gift</li>) },
				{ details: (<li><span>+</span> Quarterly Tactical Master Video Series</li>) },
				{ details: (<li><span>+</span> Quarterly Attorney Insider Video Series</li>) },
				{ details: (<li><span>+</span> Elite Partner Discounts</li>) },
				{ details: (<li><span>+</span> Priority Service</li>) }
			]
		},
		[Brands.CabelasShield]: {
			[Levels.Gold]: [
				{ details: (<li>Self Defense Liability Insurance<sup>1</sup></li>) },
				{ details: (<li>24/7/365 Critical Response Team</li>) },
				{ details: (<li>Cabela's Shield Online Training Academy</li>) },
				{ details: (<li>Customized Travel Reciprocity Map</li>) },
				{ details: (<li><em>Concealed Carry Magazine</em> Subscription Digital Only</li>) },
				{ details: (<li><em>Concealed Carry Magazine</em> Digital Archive (1yr)</li>) },
				{ details: (<li>Access to 30+ Guides & eBooks</li>) },
				{ details: (<li>Earn $50 in CLUB Points or a $25 Bass Pro Shops&nbsp;/&nbsp;Cabela's Shield Gift Card</li>) }
			],
			[Levels.Platinum]: [
				{ details: (<li>Self Defense Liability Insurance<sup>1</sup></li>) },
				{ details: (<li>24/7/365 Critical Response Team</li>) },
				{ details: (<li>Cabela's Shield Online Training Academy</li>) },
				{ details: (<li>Customized Travel Reciprocity Map</li>) },
				{ details: (<li><em>Concealed Carry Magazine</em> Subscription</li>) },
				{ details: (<li><em>Concealed Carry Magazine</em> Digital Archive (5yr)</li>) },
				{ details: (<li>Access to 40+ Guides & eBooks</li>) },
				{ details: (<li>Discounted In-Store Training Classes (Save 50%)<sup>2</sup></li>) },
				{ details: (<li>My Concealed Carry Permit Management Center</li>) },
				{ details: (<li>New Quarterly Training Videos</li>) },
				{ details: (<li>Earn $75 in CLUB Points or a $50 Bass Pro Shops&nbsp;/&nbsp;Cabela's Shield Gift Card</li>) }
			],
			[Levels.Elite]: [
				{ details: (<li>Self Defense Liability Insurance<sup>1</sup></li>) },
				{ details: (<li>24/7/365 Critical Response Team</li>) },
				{ details: (<li>Cabela's Shield Online Training Academy</li>) },
				{ details: (<li>Customized Travel Reciprocity Map</li>) },
				{ details: (<li><em>Concealed Carry Magazine</em> Subscription</li>) },
				{ details: (<li><em>Concealed Carry Magazine</em> Digital Archive (Complete)</li>) },
				{ details: (<li>Access to 80+ Guides & eBooks</li>) },
				{ details: (<li>Free In-Store Training Classes<sup>2</sup></li>) },
				{ details: (<li>My Concealed Carry Permit Management Center</li>) },
				{ details: (<li>New Quarterly Training Videos</li>) },
				{ details: (<li>Elite Priority Concierge Service</li>) },
				{ details: (<li>Earn $100 in CLUB Points or a $75 Bass Pro Shops&nbsp;/&nbsp;Cabela's Shield Gift Card</li>) }
			]
		}
	};

	public static getBenefitDetails({ brand, level, isMobile = false }: {
		brand: Brands;
		level: Levels;
		isMobile?: boolean;
	}): ReactElement[] {
		let brandLevelData = LevelSelectionChartData.data[brand][level];

		if (isMobile) {
			brandLevelData = brandLevelData.filter(benefit => !benefit.hideOnMobile);
		}

		const benefitDetails = brandLevelData.map(benefit => benefit.details);

		return benefitDetails;
	}
}
